var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoPopulation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0384 20.8333C25.935 20.8333 27.6217 21.7687 28.6955 23.2203C28.9266 23.5327 29.0421 23.6889 29.0383 23.9001C29.0354 24.0632 28.9352 24.2689 28.8095 24.3696C28.6469 24.5 28.4215 24.5 27.9708 24.5H26.0384M24.0384 19C25.5253 19 26.7307 17.7688 26.7307 16.25C26.7307 14.7312 25.5253 13.5 24.0384 13.5C23.2024 13.5 22.4554 13.8892 21.9616 14.5M15.9616 20.8333C14.065 20.8333 12.3783 21.7687 11.3046 23.2203C11.0734 23.5327 10.9579 23.6889 10.9617 23.9001C10.9646 24.0632 11.0649 24.2689 11.1905 24.3696C11.3531 24.5 11.5785 24.5 12.0292 24.5H13.9616M15.9616 19C14.4747 19 13.2693 17.7688 13.2693 16.25C13.2693 14.7312 14.4747 13.5 15.9616 13.5C16.7976 13.5 17.5447 13.8892 18.0385 14.5M15.3814 25.2203C16.4552 23.7687 18.1418 22.8333 20.0384 22.8333C21.935 22.8333 23.6216 23.7687 24.6954 25.2203C24.9265 25.5327 25.0421 25.6889 25.0383 25.9001C25.0354 26.0632 24.9351 26.2689 24.8095 26.3696C24.6468 26.5 24.4215 26.5 23.9708 26.5H16.106C15.6553 26.5 15.4299 26.5 15.2673 26.3696C15.1417 26.2689 15.0414 26.0632 15.0385 25.9001C15.0347 25.6889 15.1503 25.5327 15.3814 25.2203ZM22.7307 18.25C22.7307 19.7688 21.5253 21 20.0384 21C18.5515 21 17.3461 19.7688 17.3461 18.25C17.3461 16.7312 18.5515 15.5 20.0384 15.5C21.5253 15.5 22.7307 16.7312 22.7307 18.25Z",
    stroke: "#118F84",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoPopulation);
export default __webpack_public_path__ + "static/media/info-population.1c7601a5ede8476adb324808f1094ea3.svg";
export { ForwardRef as ReactComponent };